import {AttachAllFormField, ForceSelectData} from "../types/telegram-attach-all-adverts-modal.types";
import {Validators} from "@angular/forms";

export const telegramAttachAllAdvertsModalName = 'telegram-attach-all-adverts';

export const attachAllFormFields: Array<AttachAllFormField> = [
  {
    label: 'Дата начала периода',
    fieldName: 'dateFrom',
    type: 'date',
    validators: [Validators.required]
  },
  {
    label: 'Дата конца периода',
    fieldName: 'dateTo',
    type: 'date',
    validators: [Validators.required]
  },
  {
    label: 'Тип привязки',
    fieldName: 'force',
    type: 'select'
  }
]

export const forcesSelectData: Array<ForceSelectData> = [
  {
    displayValue: 'Все контакты заново',
    value: true
  },
  {
    displayValue: 'Только не заполненные',
    value: false
  }
]
